import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
// import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams } from "@/utils/ruoyi";
import baseURL from './base';
import utils from '@/utils/getApiSign';
import router from '@/router/index.js';
const {baseUrl} = baseURL
// console.log({baseUrl}, {baseURL})
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: `/api`,
  // baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 10000 * 2
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token（登录页白名单接口传 isToken: false）
  const headers = config.headers || {}
  const isToken = headers.isToken === false || headers['isToken'] === false
  if (isToken) {
    // 白名单：确保不携带 Authorization
    if (headers.Authorization) delete headers.Authorization
    if (headers.authorization) delete headers.authorization
    if (typeof headers.delete === 'function') {
      headers.delete('Authorization')
      headers.delete('authorization')
    }
  } else {
    try {
      const token = getToken()
      if (token) {
        headers['Authorization'] = 'Bearer ' + token
      }
    } catch (e) {
      // 未登录时忽略
    }
  }
  config.headers = headers
  return config
}, error => {
  // //console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 文件流（核销码二维码等）直接返回，避免对 Blob 读 .code
  if (res.data instanceof Blob) {
    return res.data
  }
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  if (code === 401) {
    const headers = (res.config && res.config.headers) || {}
    const skipAuthDialog = headers.isToken === false || headers['isToken'] === false
    if (!skipAuthDialog) {
      MessageBox.confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        localStorage.removeItem('loginData');
        router.push('/login');
      })
    }
    return Promise.reject(new Error('登录状态已过期'))
  } else if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject(new Error(msg))
  } else {
    return res.data
  }
},
  error => {
    //console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename) {
  return service.post(url, params, {
    transformRequest: [(params) => {
      return tansParams(params)
    }],
    responseType: 'blob'
  }).then((data) => {
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}

export default service
